import { useRoleBasedCountryFilter } from 'components/UniversalFilters/RBCountryFilter';
import useSeasonIndex from 'hooks/useSeasonIndex';
import { useCallback, useEffect, useState } from 'react';
import { SUPPORTED_COUNTRIES } from 'utils/constants';

const useCountryAndSeasonIndexFilter = () => {
  const [country, setCountry] = useRoleBasedCountryFilter();
  const [seasonIndex, setSeasonIndex] = useState<string | null>(null);

  const {
    data: seasonIndexData,
    isLoading: isLoadingSeasonIndex,
    seasonIndexFilterOptions,
  } = useSeasonIndex(country);

  useEffect(() => {
    if ((seasonIndexData?.length ?? 0) > 0) {
      const currentSeason = seasonIndexData?.find(
        (data) => data?.isCurrentSeason,
      );
      setSeasonIndex(currentSeason?.id ?? null);
    }
  }, [seasonIndexData]);

  const resetFilters = useCallback(() => {
    setCountry('Indonesia');
    setSeasonIndex(null);
  }, []);

  return {
    currentCountry: country,
    currentSeasonIdx: seasonIndex,
    setCurrentCountry: setCountry,
    setCurrentSeasonIdx: setSeasonIndex,
    resetFilters,
    countryFilterOptions: SUPPORTED_COUNTRIES,
    seasonIndexData,
    seasonIndexFilterOptions,
    isLoadingSeasonIndexFilter: isLoadingSeasonIndex,
  };
};

export default useCountryAndSeasonIndexFilter;
